import React, { useState, Fragment } from "react"
import { Link } from "react-router-dom"
import {
	Collapse, Navbar, NavbarToggler, Nav, NavItem

} from "reactstrap"
// import "./styles_layouts/Navbar.css"
import logo from "../../images/logo.png"


const TopNav = ({user, token, logoutHandler}) => {
	// console.log(user)

	const [collapsed, setCollapsed] = useState(true)

	let guestLinks
	let authLinks

	//Guest
	if(!user && !token){
	// if(){
		guestLinks= (
			<Fragment>
				<NavItem>
					<Link to="/login" className="nav-link mx-1">Login</Link>
				</NavItem>

				<NavItem>
					<Link to="/register" className="nav-link register mx-1">Register</Link>
				</NavItem>
			</Fragment>
		)
	}

	//Auth
	if(token && user) {
		authLinks = (
			<Fragment>
			{ user.isAdmin === false ? //User
				<Fragment>		
					<NavItem>
						<Link to="/booking" className="nav-link mx-1">Booking</Link>
					</NavItem>

					<NavItem>
						<Link to={"/transactions/"+user._id} className="nav-link mx-1">Transactions</Link>
					</NavItem>
				</Fragment> : null }

			{ user.isAdmin ? //Admin
				<Fragment>
					<NavItem>
						<Link to="/addtour" className="nav-link mx-1">Add Tour</Link>
					</NavItem>

					<NavItem>
						<Link to="/transactions" className="nav-link mx-1">Transactions</Link>
					</NavItem>
				</Fragment> : null }

				<NavItem>
					<span className="nav-link">Hi, {user.fullname}</span>
				</NavItem>

				<NavItem>
					<Link to="/" className="nav-link" onClick={logoutHandler}>Logout</Link>
				</NavItem>
			</Fragment>
		)
	}

	return(
		<Navbar className="navabrBackground" dark expand="md">
			<Link to="/" className="navbar-brand">
				<img src={logo} alt="tours booking" className="logo"/>
			</Link>

			<NavbarToggler onClick={()=> setCollapsed(!collapsed)} className="mr-2"/>
				<Collapse isOpen={!collapsed} navbar>
					<Nav navbar className="ml-auto">

						<NavItem>
							<Link to="/" className="nav-link mx-1">Tours</Link>
						</NavItem>

						{guestLinks}

						{authLinks}

					</Nav>
				</Collapse>
		</Navbar>
	)
}
export default TopNav